import React from 'react';
import { getAppTitle, getHelpCenterLinks } from 'venn-ui-kit';
import { cn } from '@/lib/utils';

interface DesmoothingLagHelpTextProps {
  className?: string;
}

export const DesmoothingLagHelpText = ({ className }: DesmoothingLagHelpTextProps) => {
  return (
    <div className={cn('flex flex-shrink flex-col text-[14px]', className)}>
      <span className="font-bold leading-[24px]">Desmoothing Lag</span>
      <span className="text-venn-grey-80 text-balance leading-[1.3] text-[12px]">
        {getAppTitle()} will automatically calculate a lag for each investment once a proxy is chosen. View applied lags
        on the Portfolio Management page. To apply custom lags, proxy one investment at a time.{' '}
        <a
          className="text-venn-dark-blue font-bold"
          href={getHelpCenterLinks().DESMOOTHING_HELP_HREF}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      </span>
    </div>
  );
};
